import { lazy } from 'react'

export const CheckboxQuestion = lazy(() => import('./CheckboxQuestion'))
